import Game from "./game";
const game = new Game();
export default game;
